export interface IExposedInstanceLanguage {
  id: number;
  code: string;
  name: string;
  active: boolean;
}

export interface ILanguageCreationDetails {
  code: string;
  name: string;
}

export interface ILanguageModificationDetails {
  code: string;
  name: string;
}

export enum I18nTarget {
  GLORIA_PATIENT_DASHBOARD = "gloria-patient-dashboard",
  GLORIA_PATIENT_SERVER = "gloria-patient-server",
}

export interface II18nTranslation {
  lang: string;
  target: I18nTarget;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  i18n: any;
}
